enum ACTIONS {
    FETCH_ENTITIES = 'FETCH_ENTITIES',
    PATCH_ENTITY = 'PATCH_ENTITY'
}

export default ACTIONS;